import { coverOf, type CoverValue } from './memberHubLogic'

export function HubCover({ cover, wide = false }: { cover?: CoverValue; wide?: boolean }) {
  const c = coverOf(cover)
  if (!c) return null
  return (
    <div className={`mh-cover${wide ? ' mh-cover--wide' : ''}`} style={c.image ? { backgroundImage: `url("${c.image}")` } : { background: c.bg }}>
      {!c.image && (
        <>
          <span className="mh-cover-rays" aria-hidden="true" />
          <i className={`fas ${c.icon} mh-cover-ico`} aria-hidden="true" />
          <span className="mh-cover-tag">{c.tag}</span>
        </>
      )}
    </div>
  )
}
